import { AxiosRequestConfig } from 'axios'

export interface NewVsReturningParams {
  startDate: string
  endDate: string
  storeIds?: string
}

export interface NewVsReturningResponse {
  data: Array<{
    name: string
    value: number
    quantity: number
  }>
}

const getNewVsReturningUsers = (params: NewVsReturningParams): AxiosRequestConfig => ({
  url: '/dashboard/new-vs-returning-users',
  method: 'GET',
  params,
})

export { getNewVsReturningUsers }
